import HomeView from './components/Home.vue'
import LoginView from './components/Login.vue'
import AdminView from './components/Admin.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import ReportView from './components/views/Report.vue'
import MembershipTypeView from './components/views/MembershipType.vue'
import MembershipCategoryView from './components/views/MembershipCategory.vue'
import GuestTypeView from './components/views/GuestType.vue'
import GenderView from './components/views/Gender.vue'
import MaritalStatusView from './components/views/MaritalStatus.vue'
import BloodTypeView from './components/views/BloodType.vue'
import ReligionView from './components/views/Religion.vue'

import MembershipView from './components/views/Membership.vue'
import GuestView from './components/views/Guest.vue'
import GuestFormView from './components/views/GuestForm.vue'
import GroupView from './components/views/Group.vue'
import CheckInOutLocationView from './components/views/CheckInOutLocation.vue'
import GuestMembershipView from './components/views/GuestMembership.vue'

import ProductTypeView from './components/views/ProductType.vue'
import ProductCategoryView from './components/views/ProductCategory.vue'
import ProductView from './components/views/Product.vue'
import PriceView from './components/views/Price.vue'
import SalesOrderView from './components/views/SalesOrder.vue'
import SalesOrderFormView from './components/views/SalesOrderForm.vue'
import InvoiceView from './components/views/Invoice.vue'
import InvoiceFormView from './components/views/InvoiceForm.vue'
import BINView from './components/views/BIN.vue'
import CardFeeView from './components/views/CardFee.vue'

import POSView from './components/views/PointOfSales/PointOfSales.vue'
import POSCustomerView from './components/views/PointOfSales/PointOfSalesCustomer.vue'
import POSDashboardView from './components/views/POSDashboard.vue'
import POSSessionView from './components/views/POSSession.vue'
import POSSessionFormView from './components/views/POSSessionForm.vue'
import POSOrderView from './components/views/POSOrder.vue'
import POSOrderFormView from './components/views/POSOrderForm.vue'
import POSConfigView from './components/views/POSConfig.vue'

import PaymentOrderView from './components/views/PaymentOrder.vue'
import PaymentOrderFormView from './components/views/PaymentOrderForm.vue'
import PaymentView from './components/views/Payment.vue'
import PaymentFormView from './components/views/PaymentForm.vue'
import PaymentClearingView from './components/views/PaymentClearing.vue'
import PaymentClearingSessionView from './components/views/PaymentClearingSession.vue'
import PaymentClearingSessionFormView from './components/views/PaymentClearingSessionForm.vue'
import PaymentClearingDetailView from './components/views/PaymentClearingDetail.vue'

import PassCodeView from './components/views/PassCode.vue'
import PassCodeFormView from './components/views/PassCodeForm.vue'
import GateView from './components/views/Gate.vue'
import GateFormView from './components/views/GateForm.vue'
import PaymentMethodView from './components/views/PaymentMethod.vue'
import PaymentMethodFormView from './components/views/PaymentMethodForm.vue'
import ManualCheckInOutView from './components/views/ManualCheckInOut.vue'
import ManualScanCheckInOutView from './components/views/ManualScanCheckInOut.vue'

import CourtView from './components/views/Court.vue'
import CourtFormView from './components/views/CourtForm.vue'
import CourtScheduleFormView from './components/views/CourtScheduleForm.vue'
import ReservationView from './components/views/Reservation.vue'
import ReservationFormView from './components/views/ReservationForm.vue'
// import LockerView from './components/views/Golf/Locker.vue'
// import CartView from './components/views/Golf/Cart.vue'
// import CaddyProfileView from './components/views/Golf/CaddyProfile.vue'
// import GolfReservationView from './components/views/Golf/GolfReservation.vue'
// import PackageRateView from './components/views/Golf/PackageRate.vue'
// import GolfClubView from './components/views/Golf/GolfClub.vue'
// import ClubSettingView from './components/views/Golf/ClubSetting.vue'

import CompanyView from './components/views/Company.vue'
import CompanyFormView from './components/views/CompanyForm.vue'
import ProjectView from './components/views/Project.vue'
import ProjectFormView from './components/views/ProjectForm.vue'
import UserView from './components/views/User.vue'
import UserFormView from './components/views/UserForm.vue'
import BankView from './components/views/Bank.vue'
import BankAccountView from './components/views/BankAccount.vue'
import HolidayView from './components/views/Holiday.vue'
import WorkingCalendarView from './components/views/WorkingCalendar.vue'

import AuthObjectView from './components/views/AuthorizationObject.vue'
import AuthFieldView from './components/views/AuthorizationField.vue'
import RoleView from './components/views/Role.vue'
import RoleFormView from './components/views/RoleForm.vue'
import RoleMenuFormView from './components/views/RoleMenuForm.vue'
import RoleAuthObjectFormView from './components/views/RoleAuthObjectForm.vue'
import RoleAuthObjectFieldFormView from './components/views/RoleAuthObjectFieldForm.vue'

import ChangePasswordView from './components/views/ChangePassword.vue'

// import TablesView from './components/views/Tables.vue'
// import TasksView from './components/views/Tasks.vue'
// import SettingView from './components/views/Setting.vue'
// import AccessView from './components/views/Access.vue'
// import ServerView from './components/views/Server.vue'
// import ReposView from './components/views/Repos.vue'

// Routes
const routes = [
  {
    path: '/',
    component: HomeView
  },
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/pos',
    component: POSView,
    name: 'PoS',
    meta: {
      description: 'Point Of Sales',
      requiresAuth: true
    }
  },
  {
    path: '/pos-customer',
    component: POSCustomerView,
    name: 'PoS-Customer',
    meta: {
      description: 'Point Of Sales Customer View',
      requiresAuth: true
    }
  },
  {
    path: '/manualcheckinout',
    component: ManualCheckInOutView,
    name: 'ManualCheckInOut',
    meta: {
      description: 'Manual Check In/Out'
    }
  },
  {
    path: '/manualscancheckinout',
    component: ManualScanCheckInOutView,
    name: 'ManualScanCheckInOut',
    meta: {
      description: 'Manual Scan Check In/Out'
    }
  },
  {
    path: '/admin',
    component: AdminView,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'dashboard',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: 'Dashboard'}
      },
      {
        path: 'report',
        component: ReportView,
        name: 'Report',
        meta: {description: 'Report'}
      },
      {
        path: 'master/membershiptype',
        component: MembershipTypeView,
        name: 'Membership Type',
        meta: {description: 'List of Membership Type'}
      },
      {
        path: 'master/membershipcategory',
        component: MembershipCategoryView,
        name: 'Membership Category',
        meta: {description: 'List of Membership Category'}
      },
      {
        path: 'master/guesttype',
        component: GuestTypeView,
        name: 'Guest Type',
        meta: {description: 'List of Guest Type'}
      },
      {
        path: 'master/gender',
        component: GenderView,
        name: 'Gender',
        meta: {description: 'List of Gender'}
      },
      {
        path: 'master/maritalstatus',
        component: MaritalStatusView,
        name: 'Marital Status',
        meta: {description: 'List of Marital Status'}
      },
      {
        path: 'master/bloodtype',
        component: BloodTypeView,
        name: 'Blood Type',
        meta: {description: 'List of Blood Type'}
      },
      {
        path: 'master/religion',
        component: ReligionView,
        name: 'Religion',
        meta: {description: 'List of Religion'}
      },
      {
        path: 'membership',
        component: MembershipView,
        name: 'Membership',
        meta: {description: 'List of Membership'}
      },
      {
        path: 'group',
        component: GroupView,
        name: 'Group',
        meta: {description: 'List of Group: Corporate, Family, etc..'}
      },
      {
        path: 'guest',
        component: GuestView,
        name: 'Guest',
        meta: {description: 'List of Guest'}
      },
      {
        path: 'guest/guestmembership',
        component: GuestMembershipView,
        name: 'GuestMembership',
        meta: {description: 'List of Membership of Guest'}
      },
      {
        path: 'guest/form',
        component: GuestFormView,
        name: 'Guest Form',
        meta: {description: 'Detail of Guest'}
      },
      {
        path: 'checkinoutlocation',
        component: CheckInOutLocationView,
        name: 'CheckInOutLocation',
        meta: {description: 'Location of Check-In/Out'}
      },
      {
        path: 'sales/producttype',
        component: ProductTypeView,
        name: 'Product Type',
        meta: {description: 'List of Product Type'}
      },
      {
        path: 'sales/productcategory',
        component: ProductCategoryView,
        name: 'Product Category',
        meta: {description: 'List of Product Category'}
      },
      {
        path: 'sales/product',
        component: ProductView,
        name: 'Product',
        meta: {description: 'List of Product'}
      },
      {
        path: 'sales/price',
        component: PriceView,
        name: 'Price',
        meta: {description: 'List of Price'}
      },
      {
        path: 'sales/salesorder',
        component: SalesOrderView,
        name: 'Sales Order',
        meta: {description: 'List of Sales Order (SO)'}
      },
      {
        path: 'sales/salesorder/form',
        component: SalesOrderFormView,
        name: 'Sales Order Form',
        meta: {description: 'Sales Order Form'}
      },
      {
        path: 'sales/invoice',
        component: InvoiceView,
        name: 'Invoice',
        meta: {description: 'List of Customer Invoice'}
      },
      {
        path: 'sales/invoice/form',
        component: InvoiceFormView,
        name: 'Invoice Form',
        meta: {description: 'Customer Invoice'}
      },
      {
        path: 'sales/bin',
        component: BINView,
        name: 'BIN',
        meta: {description: 'List of BIN (Bank Identification Number)'}
      },
      {
        path: 'sales/cardfee',
        component: CardFeeView,
        name: 'Card Fee',
        meta: {description: 'Card Fee'}
      },
      {
        path: 'pos/dashboard',
        component: POSDashboardView,
        name: 'PoS Dashboard',
        meta: {description: 'Dashboard of PoS'}
      },
      {
        path: 'pos/session',
        component: POSSessionView,
        name: 'Session',
        meta: {description: 'List of Sessions'}
      },
      {
        path: 'pos/session/form',
        component: POSSessionFormView,
        name: 'POS Session',
        meta: {description: 'POS Session'}
      },
      {
        path: 'pos/order',
        component: POSOrderView,
        name: 'Order',
        meta: {description: 'List of Orders'}
      },
      {
        path: 'pos/order/form',
        component: POSOrderFormView,
        name: 'POS Order',
        meta: {description: 'POS Order'}
      },
      {
        path: 'pos/config',
        component: POSConfigView,
        name: 'Point of Sales',
        meta: {description: 'List of POS'}
      },
      {
        path: 'payment/order',
        component: PaymentOrderView,
        name: 'PaymentOrderList',
        meta: {
          description: 'List of Orders'
          // breadcrumb: [
          //   { name: 'PaymentOrderList', meta: { description: 'PaymentOrderList' } }
          // ]
        }
      },
      {
        path: 'payment/order/form',
        component: PaymentOrderFormView,
        name: 'PaymentOrder',
        meta: {
          description: 'Payment Order'
          // hyperlink: 'Payment Order'
        }
      },
      {
        path: 'payment/payment',
        component: PaymentView,
        name: 'PaymentList',
        meta: {description: 'List of Payments'}
      },
      {
        path: 'payment/payment/form',
        component: PaymentFormView,
        name: 'Payment',
        meta: {description: 'Payment Detail'}
      },
      {
        path: 'payment/clearing',
        component: PaymentClearingView,
        name: 'PaymentClearing',
        meta: {description: 'Payments Clearing'}
      },
      {
        path: 'payment/clearingsession',
        component: PaymentClearingSessionView,
        name: 'PaymentClearingList',
        meta: {description: 'List of Clearing Payments'}
      },
      {
        path: 'payment/clearingsession/form',
        component: PaymentClearingSessionFormView,
        name: 'PaymentClearingSession',
        meta: {description: 'Payment Clearing Session'}
      },
      {
        path: 'payment/clearingdetail',
        component: PaymentClearingDetailView,
        name: 'PaymentClearingDetailList',
        meta: {description: 'List of Clearing Payments - Details'}
      },
      {
        path: 'gate/passcode',
        component: PassCodeView,
        name: 'PassCode',
        meta: {
          description: 'List of Passcodes'
        }
      },
      {
        path: 'gate/passcode/form',
        component: PassCodeFormView,
        name: 'PassCodeForm',
        meta: {
          description: 'Passcode'
        }
      },
      {
        path: 'gate/gate',
        component: GateView,
        name: 'Gate',
        meta: {
          description: 'List of Gates'
        }
      },
      {
        path: 'gate/gate/form',
        component: GateFormView,
        name: 'GateForm',
        meta: {
          description: 'Gate Setting'
        }
      },
      {
        path: 'gate/paymentmethod',
        component: PaymentMethodView,
        name: 'PaymentMethod',
        meta: {
          description: 'List of Payment Methods'
        }
      },
      {
        path: 'gate/paymentmethod/form',
        component: PaymentMethodFormView,
        name: 'PaymentMethodForm',
        meta: {
          description: 'Payment Method Setting'
        }
      },
      {
        path: 'reservation/court',
        component: CourtView,
        name: 'Court',
        meta: {
          description: 'List of Courts'
        }
      },
      {
        path: 'reservation/court/form',
        component: CourtFormView,
        name: 'CourtForm',
        meta: {
          description: 'Court'
        }
      },
      {
        path: 'reservation/courtschedule/form',
        component: CourtScheduleFormView,
        name: 'CourtScheduleForm',
        meta: {
          description: 'Court Schedule'
        }
      },
      {
        path: 'reservation/reservation',
        component: ReservationView,
        name: 'Reservation',
        meta: {
          description: 'List of Reservations'
        }
      },
      {
        path: 'reservation/reservation/form',
        component: ReservationFormView,
        name: 'ReservationForm',
        meta: {
          description: 'Reservation'
        }
      },
      // {
      //   path: 'golf/locker',
      //   component: LockerView,
      //   name: 'Locker',
      //   meta: {
      //     description: 'Golf Locker ',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'golf/cart',
      //   component: CartView,
      //   name: 'Cart',
      //   meta: {
      //     description: 'Golf Cart ',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'golf/caddyprofile',
      //   component: CaddyProfileView,
      //   name: 'Caddy',
      //   meta: {
      //     description: 'Golf Caddy Profile ',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'golf/reservation',
      //   component: GolfReservationView,
      //   name: 'GolfReservation',
      //   meta: {
      //     description: 'Golf Reservation'
      //   }
      // },
      // {
      //   path: 'golf/package-rate',
      //   component: PackageRateView,
      //   name: 'PackageRate',
      //   meta: {
      //     description: 'Golf Package Rate',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'golf/golfclub',
      //   component: GolfClubView,
      //   name: 'GolfClub',
      //   meta: {
      //     description: 'Golf Club Setting',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'golf/clubsetting',
      //   component: ClubSettingView,
      //   name: 'ClubSetting',
      //   meta: {
      //     description: 'Golf Club Setting',
      //     requiresAuth: true
      //   }
      // },
      {
        path: 'settings/company',
        component: CompanyView,
        name: 'Company',
        meta: {description: 'List of Company'}
      },
      {
        path: 'settings/company/form',
        component: CompanyFormView,
        name: 'Company Form',
        meta: {description: 'Detail of Company'}
      },
      {
        path: 'settings/project',
        component: ProjectView,
        name: 'Project',
        meta: {description: 'List of Project'}
      },
      {
        path: 'settings/project/form',
        component: ProjectFormView,
        name: 'Project Form',
        meta: {description: 'Detail of Project'}
      },
      {
        path: 'settings/user',
        component: UserView,
        name: 'User',
        meta: {description: 'List of Users'}
      },
      {
        path: 'settings/user/form',
        component: UserFormView,
        name: 'User Form',
        meta: {description: 'Detail of User'}
      },
      {
        path: 'settings/bank',
        component: BankView,
        name: 'Bank',
        meta: {description: 'List of Bank'}
      },
      {
        path: 'settings/bankaccount',
        component: BankAccountView,
        name: 'BankAccount',
        meta: {description: 'List of Bank Account'}
      },
      {
        path: 'settings/holiday',
        component: HolidayView,
        name: 'Holiday',
        meta: {description: 'Holiday Setting'}
      },
      {
        path: 'settings/workingcalendar',
        component: WorkingCalendarView,
        name: 'WorkingCalendar',
        meta: {description: 'Working Calendar Setting'}
      },
      {
        path: 'settings/authobject',
        component: AuthObjectView,
        name: 'AuthObject',
        meta: {description: 'Authorization Objects'}
      },
      {
        path: 'settings/authfield',
        component: AuthFieldView,
        name: 'AuthField',
        meta: {description: 'Authorization Fields'}
      },
      {
        path: 'settings/role',
        component: RoleView,
        name: 'Role',
        meta: {description: 'List of Role'}
      },
      {
        path: 'settings/role/form',
        component: RoleFormView,
        name: 'Role Form',
        meta: {description: 'Role'}
      },
      {
        path: 'settings/rolemenu/form',
        component: RoleMenuFormView,
        name: 'Role Menu Form',
        meta: {description: 'Role Menu'}
      },
      {
        path: 'settings/roleauthobject/form',
        component: RoleAuthObjectFormView,
        name: 'Role AuthObject Form',
        meta: {description: 'Role AuthObject Form'}
      },
      {
        path: 'settings/roleauthobjectfield/form',
        component: RoleAuthObjectFieldFormView,
        name: 'Role AuthObjectField Form',
        meta: {description: 'Role AuthObjectField Form'}
      },
      {
        path: 'changepassword',
        component: ChangePasswordView,
        name: 'ChangePassword',
        meta: {description: 'Change Password'}
      }
      // {
      //   path: 'setting',
      //   component: SettingView,
      //   name: 'Settings',
      //   meta: {description: 'User settings page'}
      // },
      // {
      //   path: 'access',
      //   component: AccessView,
      //   name: 'Access',
      //   meta: {description: 'Example of using maps'}
      // }, {
      //   path: 'server',
      //   component: ServerView,
      //   name: 'Servers',
      //   meta: {description: 'List of our servers', requiresAuth: true}
      // }, {
      //   path: 'repos',
      //   component: ReposView,
      //   name: 'Repository',
      //   meta: {description: 'List of popular javascript repos'}
      // }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js